// extracted by mini-css-extract-plugin
export default {"slide":"TopSlider_slide__IvQBt","img":"TopSlider_img__uTyWH","name":"TopSlider_name__6OWmj"};